import { render, staticRenderFns } from "./UnresolvedTag.vue?vue&type=template&id=203d244e&scoped=true"
import script from "./UnresolvedTag.vue?vue&type=script&lang=js"
export * from "./UnresolvedTag.vue?vue&type=script&lang=js"
import style0 from "./UnresolvedTag.vue?vue&type=style&index=0&id=203d244e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203d244e",
  null
  
)

export default component.exports